import { render } from "./settlement-monthly.vue?vue&type=template&id=561b4b73"
import script from "./settlement-monthly.vue?vue&type=script&lang=js"
export * from "./settlement-monthly.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__